module.exports = __webpack_public_path__ + "img/1.a363de9f.png";